import { gql } from '@apollo/client';

export const RdGroupingTicketOrCollectionFragment = gql`
  fragment RdGroupingTicketOrCollection on RdGroupingTicketOrCollection {
    id
    identifier
    name
    kind
    ticketType
    count
    rdProjectId
    fiscalYearId
  }
`;
